<template>
  <div class="qrcode">
    <div class="qrcode__bigtitle">
      下载APP&nbsp;&nbsp;
      <span class="qrcode__orange">开启订阅</span>
    </div>
    <div class="qrcode__image">
      <img src="../../public/qrcode-ios.png" alt="" class="qrcode__img" />
    </div>
    <div class="qrcode__title">iOS下载</div>
    <div class="qrcode__image">
      <img src="../../public/qrcode-android.png" alt="" class="qrcode__img" />
    </div>
    <div class="qrcode__title">安卓下载</div>
    <div class="qrcode__bigtitle">了解更多资讯</div>
    <div class="qrcode__image">
      <img src="../../public/qrcode-mini.png" alt="" class="qrcode__img" />
    </div>
    <div class="qrcode__title">
      扫码了解
      <span class="qrcode__orange">「极氪订阅」</span>
    </div>
  </div>
</template>
<style scoped>
.qrcode {
  padding: 66px 0;
  position: relative;
}
.qrcode::after {
  content: "";
  background: url(../../public/qrcode-bg.png) center / 100% no-repeat;
  width: 120px;
  height: 155px;
  display: block;
  position: absolute;
  right: 0;
  top: 250px;
}
.qrcode__img {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qrcode__title {
  font-size: 22px;
  color: #7c7f80;
  margin: 18px auto;
  text-align: center;
}
.qrcode__bigtitle {
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #232323;
  font-weight: bold;
  margin: 36px auto;
}
.qrcode__orange {
  color: #ff5841;
}
.qrcode__bigtitle::before,
.qrcode__bigtitle::after {
  content: "";
  display: block;
  width: 60px;
  height: 3px;
  margin: 23px;
  background: linear-gradient(
    to right,
    rgba(124, 127, 128, 1),
    rgba(124, 127, 128, 0)
  );
}
.qrcode__bigtitle::before {
  background: linear-gradient(
    to left,
    rgba(124, 127, 128, 1),
    rgba(124, 127, 128, 0)
  );
}
.qrcode__image {
  width: 200px;
  height: 200px;
  border: 1px solid #9da2a5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 18px auto;
}
.qrcode__image img {
  width: 90%;
  height: 90%;
}
</style>